import axiosBase from "axios";
// import router from '@/router'
import i18n from "@/i18n.js";

// define baseUrl using .env
let baseURL = process.env.VUE_APP_API_URL_DEV;
if (process.env.NODE_ENV === "production") {
  baseURL = process.env.VUE_APP_API_URL;
}

// let baseURL ='https://134n122.mars1.mars-hosting.com/api'
// creating axios instance
const axios = axiosBase.create({
  baseURL
});

axios.interceptors.request.use(config => {
  handleRequestInterceptor(config);

  return config;
});

// list of api
const api = {
  // auth:
  login: params =>
    axios({
      url: "login",
      method: "POST",
      data: params
    }),
  logout: params =>
    axios({
      url: "login",
      method: "GET",
      params
    }),
  checkSession: () =>
    axios({
      url: "check-session",
      method: "GET"
    }),
  register: params =>
    axios({
      url: "register",
      method: "POST",
      data: params
    }),
  forgotPassword: data =>
    axios({
      url: "user/forgot-password",
      method: "POST",
      data
    }),
  patchForgotPassword: data =>
    axios({
      url: "user/forgot-password",
      method: "PATCH",
      data
    }),
  checkForgotPassword: params =>
    axios({
      url: "user/forgot-password",
      params
    }),
  verifyToken: data =>
    axios({
      url: "verify",
      method: "POST",
      data
    }),
  resendVerification: params =>
    axios({
      url: "verify/resend",
      method: "POST",
      params
    }),
  Unsubscribe: data =>
    axios({
      url: "newsletter",
      method: "DELETE",
      data
    }),
  googleLogin: params =>
    axios({
      url: "login-google",
      method: "POST",
      data: params
    }),
  setNewsletter: params =>
    axios({
      url: "newsletter",
      method: "POST",
      data: params
    }),

  // products:
  getCategories: params =>
    axios({
      url: "categories",
      method: "GET",
      params
    }),
  getRegions: params =>
    axios({
      url: "regions",
      method: "GET",
      params
    }),
  getFilters: params =>
    axios({
      url: `categories/${params.id}/filters`,
      method: "GET"
    }),
  getProducts: params =>
    axios({
      url: "products",
      method: "GET",
      params
    }),
  getSimilarProducts: id =>
    axios({
      url: `products/${id}/similar`,
      method: "GET"
    }),
  getUserProducts: id =>
    axios({
      url: `products/${id}/user`,
      method: "GET"
    }),
  editOffer: params =>
    axios({
      url: `products/${params.id}/edit-offer`,
      method: "GET",
      params
    }),
  getAllProducts: params =>
    axios({
      url: "all-products",
      method: "GET",
      params
    }),
  changeProduct: params =>
    axios({
      url: "all-products",
      method: "PATCH",
      data: params
    }),
  changeProductPromotion: params =>
    axios({
      url: `all-products/${params.pro_id}`,
      method: "PATCH",
      data: params
    }),
  createProduct: params =>
    axios({
      url: "products",
      method: "POST",
      data: params
    }),
  editProduct: params =>
    axios({
      url: `products/${params.id}`,
      method: "PATCH",
      data: params
    }),
  deleteProduct: params =>
    axios({
      url: `products/${params.id}`,
      method: "DELETE"
    }),
  getProductInfo: params =>
    axios({
      url: `products/${params.id}`,
      method: "GET"
    }),
  getProductTransactions: params =>
    axios({
      url: "offers",
      method: "GET",
      params
    }),
  getSellerInfo: params =>
    axios({
      url: `user/${params.id}`,
      method: "GET"
    }),
  getSellerRatings: params =>
    axios({
      url: `user/${params.id}/rating`,
      method: "GET"
    }),
  getGroupProducts: id =>
    axios({
      url: `groups/${id}`,
      method: "GET"
    }),
  getGroupNew: params =>
    axios({
      url: "products/new",
      method: "GET",
      params
    }),
  getGroupPopular: () =>
    axios({
      url: "products/popular",
      method: "GET"
    }),
  changeProductGroup: params =>
    axios({
      url: `all-products/${params.pro_id}`,
      method: "POST",
      data: params
    }),

  // favorites:
  getFavorites: () =>
    axios({
      url: "favorites",
      method: "GET"
    }),
  addFavorite: params =>
    axios({
      url: "favorites",
      method: "POST",
      data: params
    }),
  removeFavorite: params =>
    axios({
      url: "favorites",
      method: "DELETE",
      data: params
    }),

  // rules:
  fetchRules: () =>
    axios({
      url: "documents",
      method: "GET"
    }),
  previewRule: params =>
    axios({
      url: `documents/${params.id}/document`
    }),
  downloadRule: params =>
    axios({
      url: `documents/${params.id}/download`
    }),
  addDocument: params =>
    axios({
      url: "documents",
      method: "POST",
      data: params
    }),
  editDocument: params =>
    axios({
      url: `documents/${params.id}`,
      method: "PATCH",
      data: params
    }),
  deleteDocument: params =>
    axios({
      url: `documents/${params.id}`,
      method: "DELETE"
    }),
  // franchise
  getListFranchise: () =>
    axios({
      url: "franchise/franchise",
      method: "GET"
    }),
  addDocumentFranchise: (
    params // api/franchise/franchise POST
  ) =>
    axios({
      url: "franchise/franchise",
      method: "POST",
      data: params
    }),
  editDocumentFranchise: params =>
    axios({
      url: `franchise/franchise/${params.frd_id}`,
      method: "PATCH",
      data: params
    }),
  deleteDocumentFranchise: params =>
    axios({
      url: `franchise/franchise/${params.id}`,
      method: "DELETE"
    }),

  // myProfile:
  getBuyers: params =>
    axios({
      url: "user/buyers",
      method: "GET",
      params
    }),
  getBuyerHistory: params =>
    axios({
      url: `user/buyers/${params.id}`
    }),
  getSellers: params =>
    axios({
      url: "user/sellers",
      method: "GET",
      params
    }),
  getSellerHistory: params =>
    axios({
      url: `user/sellers/${params.id}`
    }),
  getMyPurchases: params =>
    axios({
      url: "user/purchases",
      method: "GET",
      params
    }),
  getNews: params =>
    axios({
      url: "news",
      method: "GET",
      params
    }),
  addNewNews: params =>
    axios({
      url: "news",
      method: "POST",
      data: params
    }),
  addLinksInNews: params =>
    axios({
      url: "news-links",
      method: "POST",
      data: params
    }),
  deleteNews: id =>
    axios({
      url: `news/${id}`,
      method: "DELETE"
    }),
  getNewsInfo: params =>
    axios({
      url: `news/${params}`,
      method: "GET"
    }),
  getMySales: params =>
    axios({
      url: "user/sales",
      method: "GET",
      params
    }),
  getUserInfo: params =>
    axios({
      url: params ? `user/${params.id}` : "user",
      method: "GET",
      params
    }),
  setOffer: params =>
    axios({
      url: "offers",
      method: "POST",
      data: params
    }),
  patchOffer: params =>
    axios({
      url: `offers/${params.off_id}`,
      method: "PATCH",
      data: params
    }),
  changeOffer: params =>
    axios({
      url: `offers/${params.id}/reject`,
      method: "PATCH"
    }),
  rateUser: params =>
    axios({
      url: `offers/${params.id}/rate`,
      method: "POST",
      data: params
    }),
  deleteOfferFromArchive: params =>
    axios({
      url: `user/hide-offer`,
      method: "PATCH",
      data: params
    }),
  deleteProductFromArchive: params =>
    axios({
      url: `user/hide-product`,
      method: "PATCH",
      data: params
    }),
  getTransportDropdowns: params =>
    axios({
      url: "transport-clauses",
      method: "GET",
      params
    }),
  getTransportNavalDropdowns: params =>
    axios({
      url: "transport-clauses",
      method: "GET",
      params
    }),
  getRestrictions: () =>
    axios({
      url: "restrictions",
      method: "GET"
    }),
  setSugestion: params =>
    axios({
      url: "suggestions",
      method: "POST",
      data: params
    }),
  getSugestions: params =>
    axios({
      url: "suggestions",
      method: "GET",
      params
    }),
  deleteSugestion: params =>
    axios({
      url: `suggestions/${params.id}`,
      method: "DELETE"
    }),
  getComments: params =>
    axios({
      url: "rating",
      method: "GET",
      params
    }),
  deleteComment: params =>
    axios({
      url: `rating`,
      method: "DELETE",
      params
    }),
  getCancellations: params =>
    axios({
      url: `statistics/cancellations`,
      method: "GET",
      params
    }),
  getUserDeletedAds: params =>
    axios({
      url: `statistics/cancellations/${params.user}`,
      method: "GET",
      params
    }),
  getRejections: params =>
    axios({
      url: `statistics/rejections`,
      method: "GET",
      params
    }),
  getUserRejections: params =>
    axios({
      url: `statistics/rejections/${params.user}`,
      method: "GET",
      params
    }),
  getBuyings: params =>
    axios({
      url: `statistics/purchases`,
      method: "GET",
      params
    }),
  getProductBuyings: params =>
    axios({
      url: `statistics/purchases/${params.id}`,
      method: "GET",
      params
    }),
  renew: params =>
    axios({
      url: `products/${params.id}/renew`,
      method: "POST",
      data: params
    }),

  // notifications:
  getNotifications: params =>
    axios({
      url: "notifications",
      method: "GET",
      params
    }),
  deleteNotification: id =>
    axios({
      url: `notifications/${id}`,
      method: "DELETE"
    }),
  getNotification: params =>
    axios({
      url: `notifications/${params.id}`,
      method: "GET",
      params
    }),
  seenUserNotification: params =>
    axios({
      url: `notifications/${params.id}`,
      method: "POST"
    }),
  getMessages: () =>
    axios({
      url: "messages",
      method: "GET"
    }),
  getUserMessages: params =>
    axios({
      url: `messages/${params.id}`,
      method: "GET",
      params
    }),
  sendFile: params =>
    axios({
      url: "messages/file",
      method: "POST",
      data: params
    }),
  seenUserMessages: params =>
    axios({
      url: `messages/${params.id}`,
      method: "POST"
    }),
  getNotificationsCount: () =>
    axios({
      url: "notifications/count",
      method: "GET"
    }),
  sendNotification: params =>
    axios({
      url: "notifications/send",
      method: "POST",
      data: params
    }),

  // admin:
  getCurrencies: () =>
    axios({
      url: "currency",
      method: "GET"
    }),
  getCurrenciesAll: () =>
    axios({
      url: "currency/all",
      method: "GET"
    }),
  setCurrency: params =>
    axios({
      url: "currency/all",
      method: "POST",
      data: params
    }),
  patchCurrency: params =>
    axios({
      url: "currency/all",
      method: "PATCH",
      data: params
    }),
  getNewsletter: () =>
    axios({
      url: "newsletter",
      method: "GET"
    }),
  patchNewsletter: params =>
    axios({
      url: "newsletter",
      method: "PATCH",
      data: params
    }),
  getSocialTypes: () =>
    axios({
      url: "social-types",
      method: "GET"
    }),
  getSocialTypesAll: () =>
    axios({
      url: "social-types/all",
      method: "GET"
    }),
  patchSocialType: params =>
    axios({
      url: "social-types/all",
      method: "PATCH",
      data: params
    }),
  setSocialType: params =>
    axios({
      url: "social-types/all",
      method: "POST",
      data: params
    }),
  getRestrictedWords: () =>
    axios({
      url: "restricted-words",
      method: "GET"
    }),
  patchRestrictedWords: params =>
    axios({
      url: "restricted-words",
      method: "PATCH",
      data: params
    }),
  setRestrictedWord: params =>
    axios({
      url: "restricted-words",
      method: "POST",
      data: params
    }),
  getRestrictionsAll: () =>
    axios({
      url: "restrictions/all",
      method: "GET"
    }),
  patchRestrictions: params =>
    axios({
      url: "restrictions/all",
      method: "PATCH",
      data: params
    }),
  setRestrictions: params => {
    params.locale_time = new Date().getTimezoneOffset();
    return axios({
      url: `restrictions/all`,
      method: "POST",
      data: params
    });
  },
  getClausesAll: () =>
    axios({
      url: "transport-clauses/all?type=1",
      method: "GET"
    }),
  patchClauses: params =>
    axios({
      url: "transport-clauses/all?type=1",
      method: "PATCH",
      data: params
    }),
  setClauses: params =>
    axios({
      url: "transport-clauses/all?type=1",
      method: "POST",
      data: params
    }),
  getClausesNavalAll: () =>
    axios({
      url: "transport-clauses/all?type=2",
      method: "GET"
    }),
  patchClausesNaval: params =>
    axios({
      url: "transport-clauses/all?type=2",
      method: "PATCH",
      data: params
    }),
  setClausesNaval: params =>
    axios({
      url: "transport-clauses/all?type=2",
      method: "POST",
      data: params
    }),
  getCountries: () =>
    axios({
      url: "countries/all",
      method: "GET"
    }),
  setCountries: params =>
    axios({
      url: "countries/all",
      method: "POST",
      data: params
    }),
  patchCountry: params =>
    axios({
      url: "countries/all",
      method: "PATCH",
      data: params
    }),
  getMeasurementUnits: () =>
    axios({
      url: "measurment-units",
      method: "GET"
    }),
  getMeasurementUnitsAll: () =>
    axios({
      url: "measurment-units/all",
      method: "GET"
    }),
  patchMeasurementUnits: params =>
    axios({
      url: "measurment-units/all",
      method: "PATCH",
      params
    }),
  setMeasurementUnits: params =>
    axios({
      url: "measurment-units/all",
      method: "POST",
      data: params
    }),
  getCategoriesAdmin: () =>
    axios({
      url: "categories/all",
      method: "GET"
    }),
  getParentCategories: () =>
    axios({
      url: "categories/parents",
      method: "GET"
    }),
  getChildCategories: params =>
    axios({
      url: `categories/parents/${params}`,
      method: "GET"
    }),
  setCategory: params =>
    axios({
      url: "categories/all",
      method: "POST",
      data: params
    }),
  patchCategory: params =>
    axios({
      url: "categories/all",
      method: "PATCH",
      data: params
    }),
  getCategoryId: params =>
    axios({
      url: `categories/all/${params.cat_id}`,
      method: "GET"
    }),
  adminEditCategory: params =>
    axios({
      url: `categories/all/${params.id}`,
      method: "PATCH",
      data: params
    }),
  getServices: () =>
    axios({
      url: "organisation/services/all",
      method: "GET"
    }),
  patchServices: params =>
    axios({
      url: "organisation/services/all",
      method: "PATCH",
      data: params
    }),
  setServices: params =>
    axios({
      url: "organisation/services/all",
      method: "POST",
      data: params
    }),
  getOrganisationTypeAll: () =>
    axios({
      url: "organisation/type/all",
      method: "GET"
    }),
  patchOrganisationType: params =>
    axios({
      url: "organisation/type/all",
      method: "PATCH",
      data: params
    }),
  setOrganisationType: params =>
    axios({
      url: "organisation/type/all",
      method: "POST",
      data: params
    }),
  getOrganisationType: () =>
    axios({
      url: "organisation/type",
      method: "GET"
    }),
  getOrganisationServices: () =>
    axios({
      url: "organisation/services",
      method: "GET"
    }),
  editProfileData: params =>
    axios({
      url: "user/edit-profile",
      method: "POST",
      data: params
    }),
  getAllOffers: params =>
    axios({
      url: "offers/all",
      method: "GET",
      params
    }),
  getAllUsers: params =>
    axios({
      url: "all-users",
      method: "GET",
      params
    }),
  changeUser: params =>
    axios({
      url: "all-users",
      method: "PATCH",
      data: params
    }),
  getGroups: () =>
    axios({
      url: "groups",
      method: "GET"
    }),
  getGroupsAll: () =>
    axios({
      url: "groups/all",
      method: "GET"
    }),
  getGroup: id =>
    axios({
      url: `groups/all/${id}`,
      method: "GET"
    }),
  addGroup: params =>
    axios({
      url: "groups/all",
      method: "POST",
      data: params
    }),
  deleteGroup: id =>
    axios({
      url: `groups/${id}`,
      method: "DELETE"
    }),
  editGroup: params =>
    axios({
      url: `groups/${params.grp_id}`,
      method: "PATCH",
      data: params
    }),
  getBanners: () =>
    axios({
      url: "banners",
      method: "GET"
    }),
  setBanner: params =>
    axios({
      url: "banners",
      method: "POST",
      data: params
    }),
  deleteBanner: id =>
    axios({
      url: `banners/${id}`,
      method: "DELETE"
    }),
  getTutorials: params =>
    axios({
      url: "tutorials",
      method: "GET"
    }),
  getTutorial: params =>
    axios({
      url: `tutorials/${params.tut_id}`,
      method: "GET"
    }),
  editTutorial: params =>
    axios({
      url: `tutorials/${params.tut_id}`,
      method: "PATCH",
      data: params
    }),
  getBoughtOut: params =>
    axios({
      url: "statistics/products/bought-out",
      method: "GET",
      params
    }),
  getMostBought: params =>
    axios({
      url: "statistics/products/most-bought",
      method: "GET",
      params
    }),
  getExpired: params =>
    axios({
      url: "statistics/products/expired",
      method: "GET",
      params
    }),
  getNew: params =>
    axios({
      url: "statistics/products/newest",
      method: "GET",
      params
    }),
  getNewest: params =>
    axios({
      url: "products/newest",
      method: "GET",
      params
    }),
  getStatisticGeneral: params =>
    axios({
      url: "statistics/general",
      method: "GET",
      params
    }),
  getStatisticGeneralPeriod: params =>
    axios({
      url: "statistics/general-period",
      method: "GET",
      params
    }),
  getPopularStatistics: params =>
    axios({
      url: "statistics/products/popular",
      method: "GET",
      params
    }),
  getCategoriesStatistics: params =>
    axios({
      url: "statistics/categories",
      method: "GET",
      params
    }),
  getFaqs: params =>
    axios({
      url: "faq",
      method: "GET",
      params
    }),
  getAllFaqs: params =>
    axios({
      url: "faq/all",
      method: "GET",
      params
    }),
  createFaq: params =>
    axios({
      url: "faq/all",
      method: "POST",
      data: params
    }),
  deleteFaq: params =>
    axios({
      url: `faq/all/${params.id}`,
      method: "DELETE"
    }),
  getFaqLocale: params =>
    axios({
      url: `faq/all/${params.id}`,
      method: "GET",
      params
    }),
  editFaqLocale: (params, id) =>
    axios({
      url: `faq/all/${id}`,
      method: "POST",
      data: params
    }),
  // competitions
  getSchools: params =>
    axios({
      url: `competitions/schools`,
      method: "GET",
      params
    }),
  getCompetitions: () =>
    axios({
      url: `competitions/competitions`,
      method: "GET"
    }),
  getActiveCompetition: () =>
    axios({
      url: `competitions/competitions/active`,
      method: "GET"
    }),
  getAdminCompetitions: params =>
    axios({
      url: `competitions/admin/competitions`,
      method: "GET",
      params
    }),
  getCompetition: params =>
    axios({
      url: `competitions/competitions/${params.id}`,
      method: "GET"
    }),
  postWork: (params, id) =>
    axios({
      url: `competitions/competitions/${id}`,
      method: "POST",
      data: params
    }),
  editWorkData: (params, id) =>
    axios({
      url: `competitions/edit-work`,
      method: "PATCH",
      data: params
    }),
  deleteWorkData: params =>
    axios({
      url: `competitions/edit-work`,
      method: "DELETE",
      params
    }),
  getWorkData: params =>
    axios({
      url: `competitions/edit-work`,
      method: "GET",
      params
    }),
  editCompetition: params =>
    axios({
      url: `competitions/admin/competitions/${params.id}`,
      method: "PATCH",
      data: params
    }),
  createCompetition: params =>
    axios({
      url: `competitions/admin/competitions`,
      method: "POST",
      data: params
    }),
  getVoter: params =>
    axios({
      url: `competitions/voter`,
      method: "POST",
      params
    }),
  checkVote: params =>
    axios({
      url: `competitions/works/${params.id}/vote`,
      method: "GET",
      params
    }),
  giveVote: params =>
    axios({
      url: `competitions/works/${params.id}/vote`,
      method: "POST",
      params
    }),
  fetchCompetitionRules: params =>
    axios({
      url: "competitions/documents",
      method: "GET",
      params
    }),
  addCompetitionDocument: params =>
    axios({
      url: "competitions/documents",
      method: "POST",
      data: params
    }),
  editCompetitionDocument: params =>
    axios({
      url: `competitions/documents/${params.id}`,
      method: "PATCH",
      data: params
    }),
  deleteCompetitionDocument: params =>
    axios({
      url: `competitions/documents/${params.id}`,
      method: "DELETE"
    }),
  deleteCompetition: params =>
    axios({
      url: `competitions/admin/competitions/${params.id}`,
      method: "DELETE",
      params
    }),
  getWorks: params =>
    axios({
      url: "competitions/admin/works",
      method: "GET",
      params
    }),
  deleteWork: params =>
    axios({
      url: `competitions/admin/works/${params.id}`,
      method: "DELETE"
    }),
  getAllCompetitions: () =>
    axios({
      url: "competitions/admin/competitions/list",
      method: "GET"
    }),
  editWork: params =>
    axios({
      url: `competitions/admin/works/${params.id}`,
      method: "PATCH",
      params
    }),
  contactUs: params =>
    axios({
      url: "suggestions-public",
      method: "POST",
      params
    }),
  // chatbot:

  getChatbotMessage: id =>
    axios({
      url: `chatbot/${id}`,
      method: "GET"
    }),
  getContract: params =>
    axios({
      url: `/offers/${params.id}/report`,
      method: "GET",
      params,
      responseType: "blob"
    })
};

function handleRequestInterceptor(config) {
  try {
    const sid = localStorage.getItem("sid");
    if (config.params && sid) {
      config.params.sid = sid;
    } else if (sid) {
      config.params = {
        sid
      };
    } else {
    }
    if (config.params) {
      config.params.locale = i18n.locale;
    } else {
      config.params = {};
      config.params.locale = i18n.locale;
    }
  } catch (err) {
    console.log("err", err);
  }
  // finally {
  //    console.log(config)
  // }
}

export { baseURL, api };
